import React, { useState, useEffect } from 'react';
import { Modal, Container, Grid, Input, Button, Icon } from 'semantic-ui-react';
import {getCompanyDocument} from '../../../firebase';

const EditarNombre = ({ onModalSubmit }) => {
    const [nombreNew, setNombre] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [boton, setBoton] = useState(true);
  
    useEffect(() => {
      const isButtonDisabled = !(nombreNew);
      setBoton(isButtonDisabled);
    }, [nombreNew]);
    
    const handleSave = async () => {
      const company = await getCompanyDocument()
      await company.update({
        name: nombreNew,
      })
      setOpenModal(false)
      setNombre('')
      onModalSubmit()
      alert("Datos Guardados")
    }
  
    return (
      <label>
      <button className='editar' onClick={()=>setOpenModal(true)}>
        <Icon name='edit' />
      </button>
      <Modal 
          open={openModal}
              onOpen={()=>setOpenModal(true)}
          onClose={()=>setOpenModal(false)}
      >
        <Modal.Header>
          <Container textAlign="center">
            Cambiar nombre del Rancho
          </Container>
        </Modal.Header>
        <Modal.Content>
          <Grid columns={2} divided >
              <Grid.Row>
                  <Grid.Column>
                      <Container textAlign='right'>Nuevo nombre:</Container>
                  </Grid.Column>
                  <Grid.Column>
                      <Container textAlign='left'>
                <Input 
                value={nombreNew}
                placeholder='Nuevo nombre'
                onChange={(e) => setNombre(e.target.value)} 
                required
                />
            </Container>
          </Grid.Column>
              </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={()=>handleSave()} disabled={boton}>Enviar</Button>
        </Modal.Actions>
      </Modal>
      </label>
    );
  };

  export default EditarNombre;
